// src/components/LoggedOut/FavoritesLogic/BookmarksSectionFavorites.jsx

import React from "react";
import { Button, Typography, List, Avatar } from "antd";
import { CloseOutlined, EyeOutlined, HeartFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo1 from "../../../images/logo1.PNG";
import "../../../styles/FavoritesDrawer.css";

const { Text } = Typography;

function BookmarksSectionFavorites({ favorites, onRemoveFavorite, onClose }) {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    const url = `/products/${encodeURIComponent(item.FCNombre)}/${item.FIProducto}`;
    navigate(url);
  };

  return (
    <div className="favorites-drawer-container">
      
      <div className="favorites-notice">
        <Text className="notice-text">
          <Text strong>Aviso de urgencia:</Text> Date prisa y contacta al vendedor,
          ¡puede que después no esté disponible el producto que buscas! 😅
        </Text>
      </div>

      {/* Lista de favoritos */}
      {favorites.length > 0 ? (
        <>
          <List
            className="favorites-list"
            itemLayout="horizontal"
            dataSource={favorites}
            renderItem={(item) => (
              <List.Item
                className="favorites-list-item"
                actions={[
                  <div
                    key="actions"
                    className="favorites-item-actions"
                  >
                    <Button
                      type="text"
                      icon={<EyeOutlined />}
                      onClick={() => handleNavigate(item)}
                      className="favorites-action-btn"
                    />
                    <Button
                      type="text"
                      icon={<CloseOutlined />}
                      onClick={() => onRemoveFavorite(item)}
                      className="favorites-action-btn"
                      danger
                    />
                  </div>,
                ]}
              >
                <List.Item.Meta
                  avatar={
                    <Avatar
                      src={item.image || logo1}
                      shape="square"
                      size={48}
                      className="favorites-avatar"
                    />
                  }
                  title={
                    <div className="favorites-item-title">
                      <HeartFilled
                        style={{ color: "#e0245e", marginRight: 4 }}
                      />
                      <Text className="favorites-item-name">
                        {item.FCNombre}
                      </Text>
                    </div>
                  }
                  description={
                    <div className="favorites-item-desc">
                      <div className="favorites-item-line">
                        <Text className="desc-label">Marca:</Text>{" "}
                        <Text className="desc-value">
                          {Array.isArray(item.FCMarca)
                            ? item.FCMarca.join(", ")
                            : item.FCMarca}
                        </Text>
                      </div>
                      <div className="favorites-item-line">
                        <Text className="desc-label">Precio:</Text>{" "}
                        <Text className="desc-value">
                          ${Number(item.FNPrecioVenta).toFixed(2)}
                        </Text>
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />

          
        </>
      ) : (
        <>
        <Text className="favorites-empty-text">
          No tienes artículos marcados como favoritos.
        </Text>
          <div className="favorites-logo-footer">
          <img
            src={logo1}
            alt="Mercanteo México"
            className="favorites-logo-image"
          />
        </div>
        </>
      )}
    </div>
  );
}

export default BookmarksSectionFavorites;
